export default {
  // 错误消息
  errors: {
    failedToUploadLogo: "Logo 上传失败，请稍后重试。",
  },
  
  // 表单验证消息
  validation: {
    organizationNameRequired: "请输入组织名称",
    nameTooLong: "名称长度不能超过 256 个字符。",
  },
  
  // 表单占位符
  placeholders: {
    organizationName: "组织名称",
  },
};
